export const messages = {
  en: {
    shopServiceRule: {
      queryCondition: 'Query Condition',
      serviceFeeRule: 'Service Fee Rule',
      typeName: 'Type Name',
      serviceFee: 'Service Fee',
      communityFee: 'Community Fee',
      profitFee: 'Profit Fee',
      remark: 'Remark',
      createTime: 'Create Time',
      addServiceRule: 'Add Service Rule',
      editServiceRule: 'Edit Service Rule',
      inputTypeName: 'Please enter type name',
      inputCommunityFee: 'Please enter community fee',
      inputProfitFee: 'Please enter profit fee',
      inputRemark: 'Please enter remark',
      feeRequired: 'Fee is required',
      feeFormatError: 'Fee format is incorrect, supports up to 4 decimal places',
      feeRangeError: 'Fee must be between 0 and 100'
    }
  },
  zh: {
    shopServiceRule: {
      queryCondition: '查询条件',
      serviceFeeRule: '服务费设置',
      typeName: '类型名称',
      serviceFee: '服务费',
      communityFee: '物业分红',
      profitFee: '平台利润',
      remark: '备注',
      createTime: '创建时间',
      addServiceRule: '添加服务费设置',
      editServiceRule: '编辑服务费设置',
      inputTypeName: '请输入类型名称',
      inputCommunityFee: '请输入物业分红',
      inputProfitFee: '请输入平台利润',
      inputRemark: '请输入备注',
      feeRequired: '费用不能为空',
      feeFormatError: '费用格式不正确，最多支持4位小数',
      feeRangeError: '费用必须在0-100之间'
    }
  }
}
